module.exports = __webpack_public_path__ + "img/edge_restauration_pizza.f05bfeaf.svg";